import { MeasureController } from "../../MeasureController";
import { JudgmentResult, JudgmentResultType, JudgmentResultEnum } from "../../types.client";
import { TxOutputMeasure } from "../../../models/schemas/measures/communication.schema";

/**
 * 송신 출력 컨트롤러
 * 판정 기준: 측정값 <= 기준값 (기본 10mW)
 */
export class TxOutputController extends MeasureController<TxOutputMeasure> {
  protected getDefaultData(): TxOutputMeasure {
    return {
      standardValue: 10, // 기본 10mW
      measuredValue: 0,
      unit: "mW",
      result: null,
      discussion: "",
      remark: "",
      photo: { checkUrl: "", resultUrl: "" },
    };
  }

  protected judge(): JudgmentResult {
    const { standardValue, measuredValue } = this.data;

    // 데이터 미입력 시
    if (
      standardValue === undefined ||
      standardValue === null ||
      measuredValue === undefined ||
      measuredValue === null
    ) {
      return {
        result: JudgmentResultEnum.NA,
        discussion: this.generateDiscussion(JudgmentResultEnum.NA),
      };
    }

    // 판정: 측정값 <= 기준값
    const result: JudgmentResultType =
      measuredValue <= standardValue ? JudgmentResultEnum.GOOD : JudgmentResultEnum.BAD;

    return {
      result,
      discussion: this.generateDiscussion(result),
    };
  }

  protected generateDiscussion(result: JudgmentResultType): string {
    if (result === JudgmentResultEnum.NA) {
      return "데이터 미입력";
    }

    const { standardValue, measuredValue } = this.data;

    if (result === JudgmentResultEnum.GOOD) {
      return `송신 출력이 기준값(${standardValue}mW) 이하로 정상`;
    }

    return `송신 출력이 기준값 초과 (${measuredValue}mW > ${standardValue}mW). 점검 필요`;
  }
}
